/** Atmospheric ink-wash mountain backdrop for the menu screens (pure SVG/CSS, no assets). */
export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden="true">
      <div className="moon" />
      <svg viewBox="0 0 1600 600" preserveAspectRatio="xMidYMax slice">
        <defs>
          <linearGradient id="far" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#3b4459" stopOpacity="0.85" />
            <stop offset="1" stopColor="#1d2230" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="mid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#262b39" />
            <stop offset="1" stopColor="#15161c" />
          </linearGradient>
          <linearGradient id="near" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#17181f" />
            <stop offset="1" stopColor="#0f1014" />
          </linearGradient>
        </defs>
        <path
          fill="url(#far)"
          d="M0 330 L120 250 L210 300 L330 150 L420 260 L520 200 L640 290 L760 120 L860 240 L980 180 L1100 280 L1220 140 L1330 250 L1450 190 L1600 270 L1600 600 L0 600Z"
        />
        <path
          fill="url(#mid)"
          d="M0 420 L160 330 L260 380 L380 280 L500 370 L610 320 L720 400 L860 300 L990 390 L1120 320 L1250 400 L1380 330 L1500 380 L1600 340 L1600 600 L0 600Z"
        />
        {/* Pagoda silhouette on the middle ridge */}
        <g fill="#191b23" transform="translate(842 228)">
          <rect x="-6" y="0" width="12" height="80" />
          <path d="M-34 18 Q0 4 34 18 L22 14 L-22 14Z" />
          <path d="M-28 38 Q0 25 28 38 L18 34 L-18 34Z" />
          <path d="M-22 56 Q0 45 22 56 L14 52 L-14 52Z" />
          <rect x="-1.5" y="-14" width="3" height="16" />
        </g>
        <path
          fill="url(#near)"
          d="M0 520 L140 450 L300 500 L470 430 L620 490 L800 440 L980 510 L1160 450 L1330 500 L1480 460 L1600 490 L1600 600 L0 600Z"
        />
        {/* Pine on the near ridge */}
        <g fill="#0e0f13" transform="translate(1310 452)">
          <rect x="-3" y="0" width="6" height="40" />
          <path d="M0 -60 L28 -20 L12 -22 L34 6 L-34 6 L-12 -22 L-28 -20Z" />
        </g>
      </svg>
      <div className="mist" />
    </div>
  );
}
